import { useState } from "react";
import { Box, Chip } from "@mui/material";
import { DELTA_ACCENT } from "../colors";
import OfficersTable from "./OfficersTable";
import { DirectorNetworkPanel } from "./DirectorNetworkPanel";

const SHARED_DIRECTORSHIPS_ID = "shared-directorships";

const scrollToSection = (id: string) => {
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
};

// Shared Directorships sits below the main Officers table rather than above
// it - it's a secondary, "worth knowing" insight, not the primary content of
// the tab, so it shouldn't push the thing people actually came here for
// further down the page. The jump-link only appears once the (separate,
// slower) fan-out fetch actually resolves with something to show.
export const OfficersPanel = (props: { companyNo: string | undefined }) => {
  const { companyNo } = props;
  const [hasSharedDirectorships, setHasSharedDirectorships] = useState(false);

  return (
    <Box>
      {hasSharedDirectorships && (
        <Box style={{ display: "flex", gap: 8, flexWrap: "wrap", padding: "20px 20px 12px" }}>
          <Chip
            label="Shared Directorships"
            size="small"
            variant="outlined"
            onClick={() => scrollToSection(SHARED_DIRECTORSHIPS_ID)}
            style={{ borderColor: DELTA_ACCENT, color: DELTA_ACCENT }}
          />
        </Box>
      )}
      <OfficersTable companyNo={companyNo} />
      <DirectorNetworkPanel companyNo={companyNo} id={SHARED_DIRECTORSHIPS_ID} onHasData={setHasSharedDirectorships} />
    </Box>
  );
};

export default OfficersPanel;
